import { render, staticRenderFns } from "./infoItems.vue?vue&type=template&id=0974157c&scoped=true&"
import script from "./infoItems.vue?vue&type=script&lang=js&"
export * from "./infoItems.vue?vue&type=script&lang=js&"
import style0 from "./infoItems.vue?vue&type=style&index=0&id=0974157c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0974157c",
  null
  
)

export default component.exports